import { TaskConstants } from "../../../../constants/workflow/TaskConstants";
import { convertDateToStringDDMMYYYY, convertDateToUtcStartOfDay, isPastDateByDay } from "../../../../utils";

/**
 * Whether a milestone is past its deadline. A completed milestone is never overdue — finishing late
 * is not the same as still being late — which matches how the Kanban board treats its Complete lane.
 */
export const isMilestoneOverdue = (deadlineDate?: Date, status?: string): boolean => {
  if (!deadlineDate || status === TaskConstants.TASK_STATUS_COMPLETE) {
    return false;
  }

  return isPastDateByDay(convertDateToUtcStartOfDay(deadlineDate), convertDateToUtcStartOfDay(new Date()));
};

/** "Ada Lovelace" → "AL", for the card avatar when the API gives only a display name. */
export const getMilestoneAssigneeInitials = (name?: string): string | undefined => {
  if (!name) return undefined;

  const initials = name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");

  return initials || undefined;
};

/** The card takes a `DD/MM/YYYY` string; an absent deadline stays absent so the card omits the dot. */
export const getMilestoneDueDate = (deadlineDate?: Date): string | undefined =>
  deadlineDate ? convertDateToStringDDMMYYYY(deadlineDate) : undefined;
